<template>
	<div class="">
		<div class="back-arrow pl-6 pt-2">
			<router-link to="/template">
				<i class="fa fa-fw fa-arrow-left" />
				<span> Back to templates </span>
			</router-link>
		</div>
		<base-page-heading
			title="Template State Edit"
			subtitle=""
			class="d-print-none"
		>
			<template #extra>
				<b-button
					ref="btnShow"
					type="submit"
					size="lg"
					variant="secondary"
					@click="updateTemplateStateEdit"
				>
					Save changes
				</b-button>
			</template>
		</base-page-heading>

		<div class="row content">
			<EditTemplateStateEdit
				ref="editTemplateStateEdit"
				:template-state-id="$route.params.id"
				@routeTemplateState="routeTemplateState"
			/>
		</div>
	</div>
</template>

<style scoped>
.back-arrow{
	background-color: #f6f7f8;
}
</style>
